module.exports = __webpack_public_path__ + "static/media/logo-light.cf59e21d.png";